/**
 * Error personalizado para manejar casos específicos de pedidos web.
 */
export class WebOrderError extends Error {
  public readonly type: 'no-invoice' | 'no-results';
  public readonly docId?: string;
  public readonly customMessage?: string;
  public readonly customIcon?: string;

  constructor(
    type: 'no-invoice' | 'no-results',
    docId?: string,
    customMessage?: string,
    customIcon?: string
  ) {
    let message: string;

    if (type === 'no-invoice') {
      message =
        customMessage ||
        `El pedido "${docId}" aún no ha sido facturado. Una vez haya sido procesado podrás visualizarlo en la tabla de facturas.`;
    } else {
      message = customMessage || 'No se encontraron resultados para tu búsqueda.';
    }

    super(message);
    this.name = 'WebOrderError';
    this.type = type;
    this.docId = docId;
    this.customMessage = customMessage;
    this.customIcon = customIcon;
  }
}
